import axios from 'axios';

axios.defaults.withCredentials = true;

/**
 * Correlate browser → server → Better Stack logs for a single user action.
 */
export function newClientRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `cli_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

/**
 * Send a structured client event to the server (logged to Better Stack). Fire-and-forget safe.
 */
export async function logClientEventToServer(event, meta = {}, clientRequestId = null) {
  try {
    await axios.post(
      '/api/client-log/event',
      { event, meta: meta || {}, clientRequestId },
      { timeout: 8000, withCredentials: true }
    );
  } catch (e) {
    console.warn('[client-log]', event, e?.message || e);
  }
}
